var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPushIosStatusbar(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 402,
    height: 53,
    viewBox: "0 0 402 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rich push notifications - iOS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "col-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Lockscreen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Status Bar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Battery"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Border",
    opacity: 0.35,
    x: 342.7,
    y: 23.1,
    width: 24,
    height: 12,
    rx: 3.8,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cap",
    opacity: 0.4,
    d: "M368.1 27.2666V31.2666C368.905 30.9278 369.428 30.1397 369.428 29.2666C369.428 28.3935 368.905 27.6054 368.1 27.2666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Capacity",
    x: 344,
    y: 24.6,
    width: 21,
    height: 9,
    rx: 2.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Wifi",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.863 32.2336C325.253 30.9442 327.289 30.9441 328.679 32.2336C328.749 32.3029 328.79 32.4009 328.792 32.5041C328.794 32.6075 328.757 32.708 328.689 32.7805L326.512 35.1896C326.449 35.2603 326.362 35.2999 326.271 35.3C326.18 35.3 326.093 35.2605 326.029 35.1896L323.852 32.7805C323.785 32.708 323.748 32.6075 323.75 32.5041C323.752 32.4008 323.793 32.3028 323.863 32.2336ZM320.835 29.3615C323.899 26.5242 328.643 26.5242 331.707 29.3615C331.776 29.4281 331.816 29.5197 331.817 29.6154C331.818 29.7108 331.78 29.8025 331.713 29.8703L330.425 31.1652C330.292 31.2974 330.078 31.3006 329.942 31.1721C328.936 30.2651 327.627 29.7628 326.269 29.7629C324.913 29.7635 323.605 30.2657 322.599 31.1721C322.463 31.3005 322.25 31.2974 322.117 31.1652L320.83 29.8703C320.762 29.8026 320.725 29.711 320.725 29.6154C320.726 29.5197 320.766 29.4281 320.835 29.3615ZM317.808 26.4201C322.539 22.1266 330.003 22.1265 334.734 26.4201C334.803 26.4839 334.841 26.5714 334.842 26.6623C334.842 26.753 334.804 26.84 334.737 26.9045L333.439 28.1447C333.306 28.272 333.089 28.2739 332.953 28.1486C331.15 26.5258 328.758 25.6204 326.271 25.6203C323.784 25.6203 321.391 26.5257 319.589 28.1486C319.453 28.2739 319.236 28.2721 319.102 28.1447L317.804 26.9045C317.737 26.84 317.699 26.753 317.7 26.6623C317.701 26.5713 317.74 26.4839 317.808 26.4201Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cellular Connection",
    d: "M293.134 30.5004C293.723 30.5006 294.2 31.0149 294.2 31.6498V33.9496C294.2 34.5845 293.723 35.0997 293.134 35.1H292.066C291.477 35.0998 291 34.5846 291 33.9496V31.6498C291 31.0148 291.477 30.5005 292.066 30.5004H293.134ZM298.434 28.1C299.023 28.1001 299.5 28.6227 299.5 29.267V33.933C299.5 34.5772 299.023 35.0998 298.434 35.1H297.366C296.777 35.0997 296.3 34.5771 296.3 33.933V29.267C296.3 28.6228 296.777 28.1002 297.366 28.1H298.434ZM303.833 25.5004C304.422 25.5004 304.9 26.0156 304.9 26.6517V33.9476C304.9 34.5839 304.422 35.1 303.833 35.1H302.767C302.178 35.0999 301.7 34.5838 301.7 33.9476V26.6517C301.7 26.0156 302.178 25.5004 302.767 25.5004H303.833ZM309.134 23.1C309.723 23.1002 310.2 23.6038 310.2 24.225V33.975C310.2 34.5961 309.723 35.0997 309.134 35.1H308.066C307.477 35.0998 307 34.5962 307 33.975V24.225C307 23.6037 307.477 23.1001 308.066 23.1H309.134Z",
    fill: "white"
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushIosStatusbar);
export default __webpack_public_path__ + "static/media/push_ios_statusbar.2f02c3f16593d8f7e0dc4d7fdea12f67.svg";
export { ForwardRef as ReactComponent };